export enum PartOperation {
  Part91 = '91',
  Part135 = '135'
}
